export const DIGITAL_NAME_CARD_BASE_PATH = "/dnc";

export const getDncNotFoundRedirectUrl = (lang: string) =>
  ({
    en: "https://www.prudential.com.hk/en/index.html",
    zhhk: "https://www.prudential.com.hk/tc/index.html",
  }[lang]);